module.exports = __webpack_public_path__ + "img/revenue.71d8765f.svg";